module.exports = __webpack_public_path__ + "img/11.dad5113a.jpg";